import { OtpService } from "@/services";
import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "otp-verify",
  components: {},
  props: {
    otpType: {
      required: true
    }
  },
  data() {
    return {
      channelLabel: []
    };
  },
  computed: {
    ...mapGetters({
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    })
  },
  mounted() {
    this.getOtpStatus();
  },
  methods: {
    getOtpStatus() {
      let refNo = this.$route.params.id;
      OtpService.otpChannels(this.otpType, refNo).then(res => {
        res.data.data.forEach(data => {
          if (
            data.channel === "sms" &&
            data.active === true &&
            data.active !== this.userVerifyInfo["is_mobile_verified"]
          ) {
            this.channelLabel.push(this.$t("otpOrder.email"));
          }
          if (
            data.channel === "email" &&
            data.active === true &&
            data.active !== this.userVerifyInfo["is_email_verified"]
          ) {
            this.channelLabel.push(this.$t("otpOrder.mobile"));
          }
          if (
            data.channel === "google2fa" &&
            data.active === true &&
            data.active !== this.userVerifyInfo["is_google2fa_active"]
          ) {
            this.channelLabel.push(this.$t("otpOrder.google"));
          }
        });
        this.$emit("channelLabel", this.channelLabel);
      });
    }
  }
};
